import { ReactNode } from 'react';

import { HiddenElementsContext } from './context';

type Props = {
  children: (hiddenElementsCount: number) => ReactNode;
};

export const HiddenElementsCounter = ({ children }: Props) => {
  return (
    <HiddenElementsContext.Consumer>{children}</HiddenElementsContext.Consumer>
  );
};
